import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { hideNotification } from 'actions/notification';
import { Notification } from '@cuemath/intel';

const NotificationWrapper = ({ actions, notification }) => {
  const {
    avatarUrl,
    Component,
    duration = null,
    gap,
    gutter,
    horizontalDist,
    notificationTheme,
    position,
    props,
    showCloseIcon,
    text,
    verticalDist,
    visible,
  } = notification || {};

  const closeNotification = () => {
    actions.hideNotification();
  };

  return (
    <Notification
      avatarUrl={avatarUrl}
      Component={Component}
      componentProps={props}
      duration={duration}
      gap={gap}
      gutter={gutter}
      hideNotification={() => closeNotification()}
      horizontalDist={horizontalDist}
      notificationTheme={notificationTheme}
      position={position}
      showCloseIcon={showCloseIcon}
      text={text}
      verticalDist={verticalDist}
      visible={visible}
    />
  );
};

NotificationWrapper.propTypes = {
  actions: PropTypes.shape({
    hideNotification: PropTypes.func.isRequired,
  }).isRequired,
  notification: PropTypes.shape({}),
};

NotificationWrapper.defaultProps = {
  notification: {},
};

export default connect(
  ({ notification }) => ({
    notification,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        hideNotification,
      },
      dispatch,
    ),
  }),
)(NotificationWrapper);
